var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMenuHamburger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_24530",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 24530",
    transform: "translate(-335 -16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_24437",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 24437",
    transform: "translate(335 18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_13617",
    "data-name": "\\u9577\\u65B9\\u5F62 13617",
    width: 24,
    height: 2,
    fill: "#a59785"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_13618",
    "data-name": "\\u9577\\u65B9\\u5F62 13618",
    width: 24,
    height: 2,
    transform: "translate(0 9)",
    fill: "#a59785"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_13619",
    "data-name": "\\u9577\\u65B9\\u5F62 13619",
    width: 24,
    height: 2,
    transform: "translate(0 18)",
    fill: "#a59785"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_12495",
    "data-name": "\\u9577\\u65B9\\u5F62 12495",
    width: 24,
    height: 24,
    transform: "translate(335 16)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuHamburger);
export default __webpack_public_path__ + "static/media/icon_menu_hamburger.983607cac4174408796deb40a10eb717.svg";
export { ForwardRef as ReactComponent };